import { createSvgIcon } from "@mui/material/utils";

/**
 * Left with border icon.
 *
 * ![LeftWithBorderIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi40IC0yLjQgMjQuOCAyNC44IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PHBhdGggZD0iTTIuNSAyLjVWMTcuNU0xNy41IDEwSDUuODMzMzNNNS44MzMzMyAxMEwxMS42NjY3IDE1LjgzMzNNNS44MzMzMyAxMEwxMS42NjY3IDQuMTY2NjciIHN0cm9rZT0iIzEwMTgyOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPjwvc3ZnPg==)
 */
const LeftWithBorderIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 2.5V17.5M17.5 10H5.83333M5.83333 10L11.6667 15.8333M5.83333 10L11.6667 4.16667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "LeftWithBorder"
);

export default LeftWithBorderIcon;
